module.exports = __webpack_public_path__ + "img/img36.0cd18266.svg";